/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Closing_TitleInputs */

const en_platform_closing_title = /** @type {(inputs: Platform_Closing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your schedule can be live today`)
};

const pl_platform_closing_title = /** @type {(inputs: Platform_Closing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój grafik może ruszyć jeszcze dziś`)
};

/**
* | output |
* | --- |
* | "Your schedule can be live today" |
*
* @param {Platform_Closing_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_closing_title = /** @type {((inputs?: Platform_Closing_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Closing_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_closing_title(inputs)
	return en_platform_closing_title(inputs)
});